import React from 'react';

import { ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs';
import { ImporterDashboardLoader } from '@confluence/importer-dashboard/entry-points/ImporterDashboardLoader';

export const ImporterDashboardRoute = () => <ImporterDashboardLoader />;

ImporterDashboardRoute.NAVIGATION_PARAMS = () => ({
	Screen: {
		screenEvent: { name: 'IMPORTER_STATUS_DASHBOARD' },
	},
	MainLayout: {
		navView: ADMIN_HOME_ID,
	},
});
